import { useState } from 'react';
import styled from 'styled-components';
import QuantService from '../../../service/quant/Quant';

interface Props {
  open: boolean;
  onClose: () => void;
  group: string;
  memo: string;
  getQuantList: () => void;
  onEditInterest: () => void; // 관심목록 편집 모달로 전환
  qhIdx: number; // ← 추가
  groupIdx: number;
}

export default function MemoModal({
  open,
  onClose,
  group,
  memo,
  getQuantList,
  onEditInterest,
  qhIdx,
  groupIdx,
}: Props) {
  const [newMemo, setNewMemo] = useState(memo);

  if (!open) return null;

  const update = async () => {
    try {
      await QuantService.updateInterest(qhIdx, {
        memo: newMemo,
        groupIdx,
      });
      onClose();
      getQuantList();
    } catch (error) {
      console.error('update 함수에서 에러 발생:', error);
    }
  };

  return (
    <ModalOverlay onClick={onClose}>
      <ModalContainer onClick={(e) => e.stopPropagation()}>
        <Header>
          상세 분석
          <img
            src="/assets/images/close/close-dark-gray.svg"
            alt="닫기"
            onClick={onClose}
          />
        </Header>
        <GapBox>
          <BackGroup>
            <div onClick={onEditInterest}>관심목록 편집</div>
            <GroupBox>
              <Title>
                <img src="/assets/images/icon/star_blue_cicle.svg" alt="star" />
                {group}
              </Title>
              <img src="/assets/images/check/blue_check_32.svg" alt="check" />
            </GroupBox>
          </BackGroup>

          <Textarea
            value={newMemo}
            onChange={(e) => setNewMemo(e.target.value)}
            placeholder="(선택 )메모를 입력해주세요"
          />
        </GapBox>

        <ButtonBox>
          <Button onClick={onClose}>취소</Button>
          <Button02
            style={{ backgroundColor: '#008AFF', color: '#fff' }}
            onClick={update}
          >
            업데이트
          </Button02>
        </ButtonBox>
      </ModalContainer>
    </ModalOverlay>
  );
}

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.52);
  display: flex;
  justify-content: center;
  align-items: flex-end;
  z-index: 3000;
`;

const ModalContainer = styled.div`
  width: 100%;
  max-height: 780px;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  padding: 8px 0;
  border-radius: 24px 24px 0 0;
  border: 1px solid #e1e2e4;
  gap:24px;
  padding:16px;
  box-shadow:
    0 2px 8px 0 rgba(0, 0, 0, 0.12),
    0 1px 4px 0 rgba(0, 0, 0, 0.08),
    0 0 1px 0 rgba(0, 0, 0, 0.08);
    &::-webkit-scrollbar {
      display: none;
    }
  }
`;

const Textarea = styled.textarea`
  display: flex;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
  resize: none;
  height: 100px;
  background: #f7f8fc;
  border-radius: 8px;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 16px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.32px;
  color: #222;
  border: none;
  &:focus {
    outline: none;
  }
`;

const ButtonBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

const Button = styled.div`
  display: flex;
  padding: 12px 28px;
  justify-content: center;
  align-items: center;
  background: rgba(112, 115, 124, 0.08);
  border-radius: 8px;
  cursor: pointer;
  color: #616161;
  font-weight: 500;
`;
const Button02 = styled.div`
  display: flex;
  padding: 12px 28px;
  justify-content: center;
  align-items: center;
  flex: 1 0 0;
  border-radius: 8px;
  cursor: pointer;
`;

const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-weight: 500;
  font-size: 16px;
  line-height: 145%;
  letter-spacing: -2%;
  img {
    cursor: pointer;
  }
`;

const GroupBox = styled.div`
  display: flex;
  padding: 12px;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #616161;
  border-bottom: 1px solid #e1e2e4;
  flex-direction: row;
`;

const BackGroup = styled.div`
  font-size: 12px;
  line-height: 25px;
  gap: 4px;
  > div {
    font-weight: 500;
    text-align: right;
    color: #616161;
    padding: 4px;
  }
  > div:first-child {
    cursor: pointer;
  }
`;

const Title = styled.div`
  font-family: 'Spoqa Han Sans Neo';
  font-size: 14px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.28px;
  color: #616161;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

const GapBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
